export default "__VITE_ASSET__55344ae3__"